<template>
  <div>
    <section class="hero is-dark">
      <div class="hero-head">
        <nav class="navbar">
          <div class="container">
            <div class="navbar-end">
              <div class="tabs is-right">
                <ul>
                  <li>
                    <router-link :to="{ name: 'landing' }">Inicio</router-link>
                  </li>
                  <li>
                    <router-link :to="{ name: 'contactenos' }"
                      >Contáctenos</router-link
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-1">Políticas de Privacidad</h1>
          <h2 class="subtitle is-3">
            Que hacemos con tus datos y a que tienes derecho.
          </h2>
        </div>
      </div>
    </section>
    <div class="hero is-dark">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column">
              <h1 class="subtitle">
                En Yungol S.A.S. tenemos un firme compromiso de proteger su
                privacidad y los datos personales que usted nos suministra. Por
                esta razón, hemos creado esta política de privacidad de acuerdo
                a la normativa vigente relacionada con la protección de datos
                (Ley 1581 de 2012 y demás normativa de desarrollo), donde le
                explicamos cómo recolectamos información, para qué la usamos y
                cuáles son sus derechos. Recolección y tratamiento de datos
                Todos los datos personales recolectados por Yungol son proveídos
                directamente por usted o un autorizado como usuario al
                diligenciar un formulario nuestro o crear una cuenta en alguno
                de nuestros portales o programas, o al comunicarse directamente
                con nosotros por cualquier medio, bien sea para registrarse,
                solicitar información, descargar un demo, acceder a los
                servicios del portal de clientes, realizar una transacción
                comercial con nosotros, o cualquier otro fin. Yungol es
                propietario de la base de datos y podrá comunicarse con usted
                por diferentes medios, incluyendo y sin limitarse a: correo
                electrónico, teléfono, redes sociales, mensajes de texto,
                plataformas de comunicación en línea, publicidad en redes
                sociales y de display, entre otros. Yungol, además, podrá grabar
                o monitorear cualquier comunicación establecida con usted para
                fines de auditoría interna. Al aceptar estas políticas, usted
                está autorizando a Yungol para realizar cualquier acto de
                comunicación, cesión o transferencia de sus datos tanto dentro
                como fuera del territorio de Colombia, a empleados,
                distribuidores o proveedores de servicios contratados con objeto
                de proporcionarle servicios relacionados con la finalidad de
                tratamiento de dicha información. Además, Yungol podrá
                suministrar cualquier información personal a las entidades
                públicas o administrativas en ejercicio de sus funciones legales
                o por orden judicial o en cualquier otro caso permitido
                expresamente por la normativa vigente. Finalidad La información
                recolectada será usada para comunicar información sobre
                promociones, nuevos productos o servicios, prestarle servicio de
                soporte técnico, capacitación y asesoría comercial, realizar
                actividades de seguimiento comercial, auditoría, cobro de
                cartera y/o para cualquier otro fin relacionado con los
                productos y servicios ofrecidos por Yungol Derechos que le
                asisten como titular Usted, como titular de los datos podrá
                ejercer todos los derechos descritos en el artículo 8 de la ley
                1581 de 2012 y los que le otorgue la demás normativa vigente
                relacionada con la protección de datos personales. Consulta,
                acceso, actualización o eliminación de datos personales. Usted,
                como usuario de cualquier servicio o producto ofrecido por
                Yungol podrá consultar y actualizar sus datos en cualquier
                momento. Si usted es cliente de Yungol podrá acceder y
                actualizar sus datos personales directamente en el portal de
                clientes, de lo contrario, podrá comunicarse directamente con
                nosotros para verificar su información personal almacenada en
                nuestra base de datos. Sus datos también podrán ser actualizados
                por nuestros empleados o distribuidores al comunicarse
                telefónica, virtual o personalmente con usted. Igualmente, todos
                los correos enviados por Yungol, contienen un link en la parte
                final del documento para que usted pueda dejar de recibir
                nuestros correos electrónicos o modificar sus preferencias. Para
                solicitar la eliminación de sus datos personales de nuestra base
                de datos, debe escribir un correo a yungol.com con los datos que
                lo identifican a usted dentro de nuestra base de datos (cédula o
                correo electrónico), y una descripción detallada de los hechos
                que dan lugar a su petición. Una vez recibida esta solicitud, se
                iniciará el procedimiento respectivo para eliminar sus datos de
                nuestra base de datos.
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <y-Footer></y-Footer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import yFooter from "@/components/core/Footer.vue";
export default {
  computed: {
    ...mapState(["isAuthenticated"]),
  },
  methods: {
    registroGoogle() {
      this.$store.dispatch("notify", {
        message: "Este es un mensaje de prueba",
        type: "is-link",
      });
      this.$ga.event("landing", "prueba"); // con esto se registran eventos en google analytics
    },
  },
  components: {
    yFooter,
  },
};
</script>


<style>
.hero.is-primary.is-bold {
  background-image: linear-gradient(
    141deg,
    #158980 0%,
    #00d1b2 71%,
    #00e7eb 100%
  );
}
</style>


// WEBPACK FOOTER //
// src/components/core/Politicas.vue